import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ImageDisplayModalComponent } from '../../components/modal/image-display-modal/image-display-modal.component';
import { IModalController } from '../interfaces/imodal-controller';
import { ModalController } from '../modal-controller/modal-controller.service';

@Injectable({
  providedIn: 'root'
})
/// Service class to create instanciates of ImageDisplayModal
export class ImageDisplayModalController implements IModalController {

  constructor(private modalController: ModalController) { }
  
  /**
   * Prepares a new instance of ImageDisplayModal
   * @param imageSources Collection of image sources with their description
   */
  create(imageSources: { src: string, description: string }[]) {
    const title = new Subject<string>();

    this.modalController.create({
      title,
      titleAlign: "center",
      content: {
        component: ImageDisplayModalComponent,
        props: {
          title,
          srcs: imageSources
        }
      }
    });
  }

  /**
   * Adds the ImageDisplayModal instance to the page
   * @returns 
   */
  present() {
    return this.modalController.present();
  }
}
